import React from 'react';
import { Row } from 'components/Layout/Grid';

import './styles.scss';

const SacScoreBar: React.FC<{ score: number; }> = (props) => {
  const { score } = props;
  return (
    <Row className="sac-score-bar-out w-100 mt-2">
      <Row
        className="sac-score-bar-inner negative pr-1"
        style={{ width: '100%' }}
      />
      <Row
        className="sac-score-bar-inner positive pl-1"
        style={{ width: `${score}%` }}
      />
    </Row>
  );
};

export default SacScoreBar;
